import { Doc } from "@/components/Doc/Doc";
import { LabelExplainer } from "@/components/LabelExplainer/LabelExplainer";
import { InputPercent } from "@/components/_pages/ModelPage/Sidebar/InputPercent";
import {
  businessEntityTypeAtom,
  companysTaxRateAtom,
} from "@/financeModels/owasco/general";
import { numberToPercentInput, percentInputToNumber } from "@/utils/format";
import { Stack } from "@mantine/core";
import { useAtom } from "jotai";
import { TbFileInvoice } from "react-icons/tb";
import { InputSelect } from "../../Sidebar/InputSelect";

const Panel = () => {
  const [taxRate, setTaxRate] = useAtom(companysTaxRateAtom);
  const [businessEntityType, setBusinessEntityType] = useAtom(
    businessEntityTypeAtom,
  );

  return (
    <Stack gap={4}>
      <InputPercent
        labelWidth={189}
        value={numberToPercentInput(taxRate)}
        onChange={(value) => setTaxRate(percentInputToNumber(value))}
        label={
          <LabelExplainer
            label="Company's Tax Rate"
            explanation={
              <Doc path="@/docs/pages/model/sidebar/opAssCompanyTaxRate.mdx" />
            }
          />
        }
      />

      <InputSelect
        //labelWidth={140}
        label={
          <LabelExplainer
            label="Business Entity Type"
            explanation={
              <Doc path="@/docs/pages/model/sidebar/taxesBusinessEntityType.mdx" />
            }
          />
        }
        data={[
          { value: "llc", label: "LLC" },
          { value: "scorp", label: "S-Corp" },
          { value: "ccorp", label: "C-Corp" },
        ]}
        value={businessEntityType}
        onChange={(value) =>
          setBusinessEntityType(value as "llc" | "scorp" | "ccorp")
        }
      />
    </Stack>
  );
};

export const ModuleTaxes = {
  key: "Taxes",
  icon: <TbFileInvoice />,
  control: "Taxes",
  panel: <Panel />,
};
